import { SharedState } from '@trello/shared-state';

import type { FeatureNames } from './featuresInfo';

export type FeedbackResult = 'down' | 'up';

/**
 * `traceId` echoes the id the feature passed to `showFeedbackCollector`, so
 * the feature can fire its standard `aiFeedback submitted` event with the
 * viewed result's journey id without holding onto it separately.
 */
export type OnFeedbackGiven = (
  feedbackResult: FeedbackResult,
  traceId?: string,
) => void;

interface FeedbackCollectorSharedState {
  featureName?: FeatureNames;
  traceId?: string;
  flagTreatment?: boolean;
  onFeedbackGiven?: OnFeedbackGiven;
  /**
   * Extra per-instance context (e.g. which category of a multi-category
   * feature this feedback is about) merged into the feedback events and the
   * Jira submission's context field, alongside the feature's own static
   * attributes.
   */
  attributes?: Record<string, string>;
  isOpen: boolean;
}

const defaultFeedbackCollectorSharedState: FeedbackCollectorSharedState = {
  isOpen: false,
};

export const feedbackCollectorSharedState =
  new SharedState<FeedbackCollectorSharedState>(
    defaultFeedbackCollectorSharedState,
  );
